import type { Theme } from '@mui/material/styles';

export default function DateTimePicker(theme: Theme) {
  const disabledColor =
    theme.palette.mode === 'light'
      ? theme.palette.grey[400]
      : theme.palette.grey[200];
  const borderColor =
    theme.palette.mode === 'light'
      ? theme.palette.grey[500]
      : theme.palette.grey[400];

  return {
    MuiPickersPopper: {
      styleOverrides: {
        root: {
          '& .MuiMultiSectionDigitalClock-root::after': {
            display: 'none',
          },
        },
      },
    },
    MuiPickersOutlinedInput: {
      styleOverrides: {
        root: {
          '& .MuiPickersOutlinedInput-notchedOutline': {
            borderColor,
          },
          '&.Mui-disabled .MuiPickersOutlinedInput-notchedOutline': {
            borderColor: disabledColor,
          },
          '&:not(.Mui-disabled):hover .MuiPickersOutlinedInput-notchedOutline':
            {
              borderColor,
            },
          '@media (hover: none)': {
            '&:not(.Mui-disabled):hover .MuiPickersOutlinedInput-notchedOutline':
              {
                borderColor,
              },
          },
        },
      },
    },
  };
}
